import _isEmpty from 'lodash/isEmpty';
import React, { Component } from 'react';
import { Button, Form, Input } from 'antd';
import { withApollo } from '@apollo/react-hoc';
import { gql } from '@apollo/client';
import { evaluate } from '@achievable-me/tundra-wizard/evaluate';
import routes from '@achievable-me/tundra-wizard/routes';
import ReactJson from 'react-json-view';
import { reverse } from 'named-urls';

const STAFF_ITEM = gql`
  query StaffItem($input: StaffItemInput!) {
    staffItem(input: $input) {
      item {
        uuid
        code
        bundle
        format
        itemType
        transpiled
      }
    }
  }
`;

const STAFF_ITEM_UPDATE_BUNDLE = gql`
  mutation StaffItemUpdateBundle($input: StaffItemUpdateBundleInput!) {
    staffItemUpdateBundle(input: $input) {
      errors
      item {
        uuid
        bundle
        transpiled
      }
    }
  }
`;

class Evaluated extends Component {
  constructor(props) {
    super(props);

    const { transpiled } = props;
    const evaluated = evaluate(transpiled);
    this.state = {
      evaluated,
    };
  }

  handleEvaluate = () => {
    const { transpiled } = this.props;
    const evaluated = evaluate(transpiled);
    this.setState({
      evaluated,
    });
  };

  render() {
    const { evaluated } = this.state;

    return (
      <div>
        <ReactJson src={evaluated} />
        <Button onClick={this.handleEvaluate}>evaluate</Button>
      </div>
    );
  }
}

class FlashcardEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      item: null,
    };
  }

  handleItemUpdate = async (values) => {
    const { client } = this.props;
    const { bundle } = values;

    const { data } = await client.mutate({
      mutation: STAFF_ITEM_UPDATE_BUNDLE,
      variables: {
        input: {
          uuid: this.state.item.uuid,
          bundle,
        },
      },
    });

    const { staffItemUpdateBundle } = data;
    const { errors, item } = staffItemUpdateBundle;

    if (!_isEmpty(errors)) {
      alert('errors updating, check console'); // eslint-disable-line no-alert
      console.log(errors); // eslint-disable-line no-console
      return;
    }

    this.setState({
      item,
    });
  };

  handleItemSearch = async (value) => {
    const { client } = this.props;

    const { data } = await client.query({
      query: STAFF_ITEM,
      variables: {
        input: {
          code: value,
        },
      },
    });
    const {
      staffItem: { item },
    } = data;

    this.setState({
      item,
    });
  };

  renderItem = () => {
    const { item } = this.state;

    if (!item) {
      return <div>No item.</div>;
    }

    return (
      <div key={item.uuid}>
        uuid: {item.uuid}
        <br />
        code: {item.code}{' '}
        <a
          href={`${reverse(routes.study.review, { productSlug: 'achievable' })}?debug=${
            item.code
          }`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fad fa-external-link" />
        </a>
        <br />
        itemType: {item.itemType}
        <br />
        format: {item.format}
        <br />
        <br />
        <Form onFinish={this.handleItemUpdate} initialValues={{ bundle: item.bundle }}>
          <Form.Item name="bundle" rules={[{ required: true }]}>
            <Input.TextArea rows={8} />
          </Form.Item>
          <Button type="primary" htmlType="submit">
            Update
          </Button>
        </Form>
        <hr />
        {item && item.transpiled && <Evaluated transpiled={item.transpiled} />}
        <hr />
        <Input.TextArea disabled rows={8} value={item.transpiled} />
      </div>
    );
  };

  render() {
    return (
      <div>
        <Input.Search
          placeholder="item code"
          onSearch={this.handleItemSearch}
          enterButton
          style={{ width: 300 }}
        />
        <br />
        {this.renderItem()}
      </div>
    );
  }
}

export default withApollo(FlashcardEdit);
